import { createGlobalStyle } from "styled-components";
import tc from "tinycolor2";

export const GlobalStyle = createGlobalStyle`
  .table {
    thead {
      position: sticky;
      top: 0;
    }
    tbody > tr:last-child > td {
      border-bottom: 0;
    }
  }

  div.surface {
    width: 100%;
    background-color: ${({ theme }) => theme.surface};
    border-radius: 0.3125rem;

    & > .title, > * .title {
      font-weight: bold;
      font-size: 0.8rem;
      color: ${({ theme }) => tc(theme.text).darken(10)};
    }
  }

  div.surface-secondary {
    background-color: ${({ theme }) => theme.surfaceSecondary};
  }

  .text-warning {
    color: ${({ theme }) => theme.orange} !important;
  }

  .offcanvas.offcanvas-end {
    border-left: none;
}

  .table-responsive {
    overflow-x: hidden;
  }

  a.text-no-style {
    :not(:hover) {
      color: ${({ theme }) => theme.text};
      text-decoration: none;
    }
  }
`;
